// ContextMenu.js
import { cloneElement } from 'react';
import { useContextMenu } from 'contexts/ContextMenuProvider';

const ContextMenu = props => {
  const { contextMenuItems } = useContextMenu();

  return (
    <>
      {contextMenuItems &&
        contextMenuItems.length > 0 &&
        contextMenuItems.map((component, index) =>
          cloneElement(component, { key: index, ...props })
        )}
    </>
  );
};

export default ContextMenu;
